import fetch from './fetch';
import EndPoints from '../data/EndPoints';
import Methods from '../data/Methods';

export default (type) => {
	return fetch(Methods.GET, EndPoints.USER_DOCUMENT_TYPE.replace(':type', type), null, null, true);
};
